import { Route } from "vue-router";
import { getModule } from "vuex-module-decorators";
import TitleListState from "@/modules/title-list";
import CategoryManagerState from "@/modules/category-manager";
import { ContentExposureModule } from "@/modules/content-exposure";
import { VersionGroupModule } from "@/modules/versiongroup";
import UnitState from "@/modules/unit";
import { CurriculumType } from "@/util/enum";

export const ContentExposureResolver = async function (to: Route, form: Route, next: Function) {
	const titleListModule = getModule(TitleListState);
	const categoryModule = getModule(CategoryManagerState);
	const unitModule = getModule(UnitState);

	const actions: Promise<void>[] = [];
	if (!titleListModule.languageSkills.length) {
		actions.push(titleListModule.fetchLanguageSkills());
	}
	if (!titleListModule.levels.length) {
		actions.push(titleListModule.fetchVcsLevels());
	}
	if (!titleListModule.tags.length) {
		actions.push(titleListModule.fetchVcsTags());
	}
	if (!categoryModule.categories.length) {
		actions.push(categoryModule.fetchCategories());
	}
	if (to.params.id) {
		actions.push(titleListModule.fetchContentDetails(to.params.id));
	}
	if (!unitModule.units.length) {
		actions.push(unitModule.fetchUnits({ details: false }));
	}
	if (!ContentExposureModule.signatures.length) {
		actions.push(ContentExposureModule.getSignature());
	}
	await Promise.all(actions);
	const { getEditedContentDetails, editeContentSelectedChapterId, editedContentId } = titleListModule;
	const versionGroupId =
		getEditedContentDetails.curriculumType === CurriculumType.GrapeSEED
			? VersionGroupModule.selectedGsVersion
			: VersionGroupModule.selectedLsVersion;
	const vcsLevelId = getEditedContentDetails.vcsLevelId;
	const contentId = (editeContentSelectedChapterId !== "none" && editeContentSelectedChapterId !== "all") ? editeContentSelectedChapterId : editedContentId;
	ContentExposureModule.setContentVersionGroupId({ versionGroupId, contentId, vcsLevelId });
	ContentExposureModule.setContentExposures([]);
	next();
};
